import { useParams, useSearch } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { MathText } from '@jeraisonne/ui';
import { useExerciseV2 } from '@/lib/exercise-v2/api';
import { ExerciseEditorV2 } from '@/features/exercise-editor-v2';
import { QuestionReportPanel } from '@/features/exercise-editor-v2/question-report-panel';

/**
 * Éditeur V2. Plus de « Rollback V1 » : aucun exercice ne repasse en V1
 * (lot B, objectif zéro V1).
 */
export function TutorExerciseEditV2Page() {
  const { exerciseId } = useParams({ strict: false }) as { exerciseId: string };
  const { data, isPending } = useExerciseV2(exerciseId);
  // ?question / ?report : ouvert depuis un signalement (migration 0348).
  const { question, report } = useSearch({ from: '/app/tutor/exercises/$exerciseId/edit-v2' });

  // Exercice issu d'une épreuve → le retour renvoie vers l'épreuve plutôt que
  // vers le détail de l'exercice.
  const epreuveId = data?.meta.source_epreuve_id ?? null;
  const backHref = epreuveId
    ? `/tutor/admin/epreuves/${epreuveId}`
    : `/tutor/exercises/${exerciseId}`;
  const backLabel = epreuveId ? "Retour à l'épreuve" : 'Retour';

  return (
    <div className="pb-safe min-h-screen bg-slate-50">
      {/* Bouton retour mobile-first : précède le titre dans le DOM, séparé visuellement */}
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-4xl items-center justify-between gap-2 px-3 py-3 sm:px-6">
          <a
            href={backHref}
            className="inline-flex min-h-11 items-center gap-1 rounded-md px-2 text-sm text-slate-700 hover:bg-slate-100 active:scale-[0.98]"
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="hidden sm:inline">{backLabel}</span>
          </a>
          <h1 className="truncate text-sm font-semibold text-slate-800 sm:text-base">
            {isPending ? 'Chargement…' : <MathText>{data?.meta.title ?? 'Exercice'}</MathText>}
          </h1>
          <span className="w-11" aria-hidden />
        </div>
      </header>
      <main>
        {(question || report) && (
          <QuestionReportPanel
            exerciseId={exerciseId}
            questionBlockId={question}
            reportId={report}
          />
        )}
        <ExerciseEditorV2 exerciseId={exerciseId} />
      </main>
    </div>
  );
}
